/** Built-in Page Setup placeholder — not a portal-uploaded org logo. */
export const ENTERPRISE_PLACEHOLDER_LOGO_MARKER = "f5bc5113250ac95d_logo";

export function isPlaceholderNaturalsLogo(value) {
  if (value == null) return true;
  const text = String(value).trim();
  if (!text) return true;
  if (text.includes(ENTERPRISE_PLACEHOLDER_LOGO_MARKER)) return true;
  return false;
}

/**
 * Pick display logo from GET /organization/branding payload.
 * HQ (executive/workspace) prefers Nyafaz portal upload over salon org placeholder.
 */
export function pickHqBrandingLogo(branding, { isFranchise = false } = {}) {
  if (!branding || typeof branding !== "object") return null;
  const portalRaw = branding.portal_logo || branding.portal_logo_source;
  const orgRaw = branding.org_logo || branding.logo_url;

  if (isFranchise) {
    return orgRaw && !isPlaceholderNaturalsLogo(orgRaw) ? orgRaw : orgRaw || null;
  }

  if (portalRaw && !isPlaceholderNaturalsLogo(portalRaw)) return portalRaw;
  if (orgRaw && !isPlaceholderNaturalsLogo(orgRaw)) return orgRaw;
  return portalRaw || orgRaw || null;
}
